import { frag, el } from './dom';
import { presets, type Preset } from '../data/presets';

export interface InputBlock {
  onChange(fn: (text: string) => void): void;
  setText(text: string): void;
  getText(): string;
  showEnglish(on: boolean): void;
  getEnglishText(): string;
  enRenderTarget(): HTMLElement;
}

export function renderInput(root: HTMLElement): InputBlock {
  const tpl = `
    <textarea class="ow-input" rows="3" aria-label="tekst" spellcheck="false" placeholder="lim inn norsk tekst…"></textarea>
    <div class="ow-presets-inline" role="navigation" aria-label="forhåndsvalg">
      <span class="ow-presets-label">eller prøv:</span>
    </div>
    <div class="ow-en-row" hidden>
      <div class="ow-en-render" aria-label="engelsk oversettelse, fragmentert"></div>
      <div class="ow-charcount ow-charcount-en">
        <div class="ow-charcount-label">tegn engelsk</div>
        <div class="ow-charcount-num" id="ow-tegn-en">0</div>
      </div>
    </div>
  `;
  root.replaceChildren(frag(tpl));

  const presetsRoot = root.querySelector<HTMLElement>('.ow-presets-inline')!;
  presets.forEach((p, i) => {
    if (i > 0) presetsRoot.appendChild(el('span', { class: 'ow-sep', text: '·', attrs: { 'aria-hidden': 'true' } }));
    const btn = el('button', {
      class: 'ow-preset', text: p.label,
      attrs: { type: 'button', 'data-id': p.id }
    });
    presetsRoot.appendChild(btn);
  });

  const textarea = root.querySelector<HTMLTextAreaElement>('.ow-input')!;
  const enRow = root.querySelector<HTMLElement>('.ow-en-row')!;
  const enRender = root.querySelector<HTMLElement>('.ow-en-render')!;
  const enNum = root.querySelector<HTMLElement>('#ow-tegn-en')!;

  let englishText = '';
  const listeners = new Set<(t: string) => void>();

  function setText(t: string): void {
    textarea.value = t;
    listeners.forEach(fn => fn(t));
  }
  function setEnglish(t: string): void {
    englishText = t;
    enNum.textContent = String(t.length);
  }

  textarea.addEventListener('input', () => setText(textarea.value));

  root.querySelectorAll<HTMLButtonElement>('.ow-preset').forEach(btn => {
    btn.addEventListener('click', () => {
      const preset = presets.find(p => p.id === btn.dataset.id) as Preset;
      // EN must be set BEFORE NO so the rerender (fired by setText) sees fresh
      // English. See commit acfac70 for the original bug fix.
      setEnglish(preset.en);
      setText(preset.no);
      root.querySelectorAll('.ow-preset').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // No initial setText — the textarea starts empty per spec §2.

  return {
    onChange(fn) { listeners.add(fn); },
    setText, getText: () => textarea.value,
    showEnglish(on) { enRow.hidden = !on; },
    getEnglishText: () => englishText,
    enRenderTarget: () => enRender
  };
}
